<template>
    <v-card class="myprofile-popup">
        <v-card-title primary-title>
            {{memberProfileConstants.TRAINING_CERTIFICATION.EDIT_CERTIFICATIONS}}
            <i class="fas fa-times" @click="cancel(false)" data-qe-id="close_btn"></i>
        </v-card-title>
        <v-card-text class="inner-scrollbar" ref="certificationDialogId">
            <v-flex v-for="(certification, index) in certifications" :key="index" class="certification-details">
            <v-form
                :id="index"
                lazy-validation
                :ref="`certification-${certification.id}`"
                v-model="valid"
                >
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.NAME}} {{memberProfileConstants.ASTERISK}}</span>
                            <span class="select-required">{{memberProfileConstants.REQUIRED}}</span>
                            <v-flex class="autocomplete" v-on:mouseleave="isSearchOpen = false">
                                <v-text-field
                                    :placeholder="memberProfileConstants.TYPE_TO_SEARCH"
                                    @input="getSearchResults(certification)"
                                    :data-qe-id="`certification-${index}_name_input`"
                                    v-model="certification.name"
                                    required
                                    :rules="memberProfileConstants.TRAINING_CERTIFICATION.PLEASE_ENTER_CERTIFICATION_NAME"
                                    :maxlength="memberProfileConstants.MAX_NAME_COUNT_EIGHTY"
                                    @keydown.down="onArrowDown"
                                    @keydown.up="onArrowUp"
                                    @keydown.enter="onEnter(certification)"
                                    color="ypo_blue"></v-text-field>
                                <v-list
                                    v-if="isSearchVisible(certification.name) && certification.isSearch"
                                    id="autocomplete-results"
                                    v-show="isSearchOpen"
                                    class="autocomplete-results inner-scrollbar">
                                    <v-list-tile
                                        class="autocomplete-result"
                                        v-for="(result, i) in results"
                                        :key="i"
                                        :data-qe-id="`certification-${index}_autocomplete_result-${i}`"
                                        @click="setResult(certification, result)"
                                        :class="{ 'is-active': i === arrowCounter }">
                                        <v-list-tile-title v-highlight ="{keyword: certification.name, sensitive: false}">
                                        {{ result }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.WEBSITE}} </span>
                            <v-text-field
                                height="40"
                                :placeholder="memberProfileConstants.WEBSITE"
                                :data-qe-id="`certification-${index}_website_input`"
                                v-model="certification.url"
                                :rules="memberProfileConstants.WEBSITE_URL_RULE"
                                color="ypo_blue"
                                @input="edit(certification)"></v-text-field>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <span class="select-label pl-2">{{memberProfileConstants.DATE_RECEIVED}} </span>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-flex class="form-control">
                                    <v-autocomplete
                                        attach
                                        height="40"
                                        :data-qe-id="`certification-${index}_date-received`"
                                        color="ypo_blue"
                                        :items="getFullMonthNames()"
                                        v-model="certification.startMonth"
                                        :placeholder="memberProfileConstants.MONTH"
                                        v-on:change="edit(certification)"></v-autocomplete>
                                </v-flex>
                            </v-flex>
                            <v-flex xs6>
                                <v-flex class="form-control">
                                    <v-autocomplete
                                        attach
                                        height="40"
                                        :data-qe-id="`certification-${index}_start-year`"
                                        color="ypo_blue"
                                        v-model="certification.startYear"
                                        :items="getListOfYears()"
                                        :placeholder="memberProfileConstants.YEAR"
                                        v-on:change="edit(certification)"></v-autocomplete>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.INDUSTRY}} </span>
                            <v-autocomplete
                                attach
                                height="40"
                                color="ypo_blue"
                                :data-qe-id="`certification-${index}_industry`"
                                v-model="certification.industryCategory"
                                :items="Object.keys(industory).sort()"
                                v-on:input="edit(certification)"
                                :placeholder="memberProfileConstants.INDUSTRY"></v-autocomplete>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.SUB_INDUSTRY}} </span>
                            <v-autocomplete
                                attach
                                height="40"
                                color="ypo_blue"
                                :data-qe-id="`certification-${index}_sub-category`"
                                v-model="certification.subIndustryCategory"
                                :items="certification.subIndustry"
                                :no-data-text="noSubIndustry(certification.subIndustry, certification.industryCategory)"
                                :placeholder="memberProfileConstants.SUB_INDUSTRY"
                                v-on:input="edit(certification)"></v-autocomplete>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex mb-3 class="form-control">
                            <span class="select-label">{{memberProfileConstants.DESCRIPTION}} </span>
                            <v-text-field class="text-number"
                                height="40"
                                :placeholder="memberProfileConstants.DESCRIPTION"
                                :data-qe-id="`certification-${index}_description`"
                                v-model="certification.description"
                                color="ypo_blue"
                                :counter="255"
                                :maxlength="memberProfileConstants.MAX_LENGTH"
                                @input="edit(certification)"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex class="btn-row">
                        <v-btn class="primary_btn"
                            v-if="!certification.isEditDialog"
                            :disabled="!certification.isAdd || !valid"
                            :data-qe-id="`certification-${index}_add-certification`"
                            @click="addCertification(certification)">
                            <i class="fas fa-plus-circle mr-2"></i>{{memberProfileConstants.ADD_MORE}}
                        </v-btn>
                        <v-btn small
                            class="primary_btn"
                            :data-qe-id="`certification-${index}_delete-certification`"
                            @click="deleteCertification(certification.id, index)"
                            :disabled="certification.isDelete">
                            <i class="fas fa-trash-alt mr-2"></i>{{appCommonConstants.DELETE}}
                        </v-btn>
                        <v-flex class="save-to-profile" v-model="certification.isSuccess" v-if="certification.isSuccess">
                            <i class="fas fa-check"></i> <span>{{memberProfileConstants.SAVED_TO_PROFILE}}</span>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-dialog v-model="deleteInformationDialog" lazy absolute content-class="post-actions">
                    <v-card>
                        <v-flex tag="h6">{{memberProfileConstants.DIALOG_CONFIRMATION_TITLE}}
                            <v-btn icon @click="deleteInformationDialog=false" data-qe-id="close_dialog_btn">
                                <v-icon size="20">close</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex tag="p">
                            {{memberProfileConstants.DIALOG_CONFIRMATION_DESC}}
                        </v-flex>
                        <v-flex text-xs-right>
                            <status-bar :action="deleteCertificationAction"></status-bar>
                            <v-flex ma-1>
                                <v-btn flat @click="deleteInformationDialog = false" class="primary_btn transparent"
                                    data-qe-id="cancel_dialog_btn">
                                    {{memberProfileConstants.CANCEL}}
                                </v-btn>
                                <v-btn dark @click="deleteInformation()" class="primary_btn"
                                    data-qe-id="save_dialog_btn">
                                    {{memberProfileConstants.CONTINUE}}
                                </v-btn>
                            </v-flex>
                        </v-flex>
                    </v-card>
                </v-dialog>
            </v-form>
            </v-flex>
        </v-card-text>
        <status-bar :action="editCertificationAction"></status-bar>
        <status-bar :action="saveCertificationAction"></status-bar>
        <v-card-actions>
            <v-flex text-xs-right pa-3>
                <v-flex>
                    <v-btn flat class="primary_btn transparent" @click="cancel(false)" data-qe-id="certification_cancel_btn">
                        {{appCommonConstants.CANCEL}}
                    </v-btn>
                    <v-btn class="primary_btn" :disabled="!valid || !certifications[0].isSave"
                        data-qe-id="certification_save_btn"
                        @click="saveCertification()">
                        {{appCommonConstants.DONE}}
                    </v-btn>
                </v-flex>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
import { memberProfileConstants, noSubIndustry, filterResults, TrainingandCertActions } from "../memberProfile.constants.js";
import { mapState, mapActions, mapGetters } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import { storeGetters } from "../../../store/storeGetters.constant";
import { getFullMonthNames, getListOfYears } from "../../../common/utils/dateTime.js";
import StatusBar from "../../StatusBar/StatusBar";
import { uuid } from 'vue-uuid';
import Vue from 'vue';
import { appCommonConstants } from "../../appCommon.constants.js";

export default {
    name: "CertificationsDialog",
    data: () => ({
        memberProfileConstants,
        appCommonConstants,
        noSubIndustry,
        filterResults,
        uuid: uuid.v1(),
        isSearchOpen: false,
        results: [],
        isSearchLoading: false,
        arrowCounter: 0,
        subIndustry: [],
        getFullMonthNames,
        getListOfYears,
        startMonth: '',
        startYear: '',
        startDate: null,
        valid: false,
        deleteInformationDialog: false,
        certificationId: null,
        certificationDeleteIndex: null,
        postBody: {
            type: null,
            name: null,
        },
    }),
    components: {
        StatusBar,
    },
    props: {
        certifications: {
            type: Array,
            required: false,
        },
        isCertificationEditDialog: {
            type: Boolean,
            required: false,
        },
        certification: {
            type: Object,
            required: false,
        },
        memberId: {
            type: String,
            required: true,
        },
    },
    methods: {
        ...mapActions({ ...TrainingandCertActions }),
        edit(certification) {
            certification.isEdit = true;
            certification.subIndustry = this.industory[certification.industryCategory];        
        },
        addCertification(certification) {
            certification.isAdd = false;
            const [ref] = this.$refs[`certification-null`];
            if (ref.validate()) {
                certification.isEditDialog = false;
                certification.id = this.generateGUID();
                certification.personId = this.memberId;
                certification.isEdit = false;
                certification.type = this.memberProfileConstants.CERTIFICATION;
                this.setStartDate(certification);
                const postBody = [{
                    ...certification,
                }];
                this.saveTrainingAndCertification(postBody)
                    .then(() => {
                        ref.resetValidation();
                        certification.isDelete = false;
                        certification.isAdd = true;
                        certification.isSuccess = true;
                        certification.isSearch = false;
                        certification.isEditDialog = true;
                        certification.isSave = true;
                        const index = this.certifications.length;
                        //takes a bit for dom to actually update
                        setTimeout(() => {
                            document.getElementById(index).scrollIntoView();
                        }, 100);
                        this.certifications.push(Vue.util.extend({}, this.certification));
                    });
            }
        },
        deleteCertification(certificationId, index) {
            this.deleteInformationDialog = true;
            this.certificationId = certificationId;
            this.certificationDeleteIndex = index;
        },
        deleteInformation() {
            const parms = {
                companyId: this.certificationId,
                personId: this.memberId,
            };
            this.deleteTrainingAndCertification(parms)
                .then(() => {
                    this.deleteInformationDialog = false;
                    if (this.certificationDeleteIndex <= 0 && this.certifications.length === 1) {
                        this.$emit('click', false);
                    } else {
                        Vue.delete(this.certifications, this.certificationDeleteIndex);
                    }
                    this.scrollTop();
                });
        },
        saveCertification() {
            if (this.isCertificationEditDialog) {
                const [ref] = this.$refs[`certification-${this.certifications[0].id}`];
                if (ref.validate()) {
                    this.setStartDate(this.certifications[0]);
                    this.certifications[0].type = this.memberProfileConstants.CERTIFICATION;
                    const postBody = {
                        ...this.certifications[0],
                    };
                    postBody.personId = this.memberId;
                    this.updateTrainingAndCertification(postBody) 
                        .then(() => {
                            ref.resetValidation();
                            this.$emit('click', false);
                            this.scrollTop();
                        });
                }
            } else {
                const [ref] = this.$refs[`certification-null`];
                if (ref.validate()) {
                    const postbody = this.certifications.filter(x => x.isEdit === true);
                    postbody.forEach((x) => {
                        if (x.id === null) {
                            this.setStartDate(x);
                            x.id = this.generateGUID();
                            x.type = this.memberProfileConstants.CERTIFICATION;
                        }
                        x.personId = this.memberId;
                    });
                    this.saveTrainingAndCertification(postbody) 
                    .then(() => {
                        ref.resetValidation();
                        this.$emit('click', false);
                        this.scrollTop();
                    });
                }
            }
        },
        generateGUID() {
            return uuid.v1();
        },
        cancel(value) {
            this.isSave = true;
            this.resetValidation();
            this.$emit('click', value);
            this.scrollTop();
        },
        resetValidation() {
            this.certifications.forEach((x) => {
                const [ref] = this.$refs[`certification-${x.id}`];
                ref.resetValidation();
            }); 
        },
        setStartDate(certification) {
            if (certification.startMonth && certification.startYear) {
                certification.startDate = `${certification.startMonth} ${certification.startYear}`;
            } else {
                certification.startDate = null;                
            }
        },
        getSearchResults(certification) {
            certification.isEdit = true;
            certification.isAdd = true;
            certification.isSearch = true;
            certification.isSave = true;
            if (certification.name !== undefined) {
                if (certification.name.length >= this.memberProfileConstants.THREE) {
                    this.postBody.type = this.memberProfileConstants.CERTIFICATION;
                    this.postBody.name = certification.name;
                    this.searchExternalConnection(this.postBody)
                        .then(() => {
                                this.isSearchLoading = false;
                                this.results = this.filterResults(this.courseAndCertificateSearchResult, certification.name);
                                this.isSearchOpen = true;
                        });
                }
            }
        },
        setResult(certification, result) {
            certification.name = result;
            this.isSearchOpen = false;
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter(certification) {
            certification.name = this.results[this.arrowCounter];
            this.isSearchOpen = false;
            this.arrowCounter = -1;
        },
        isSearchVisible(certificationName) {
            if (certificationName !== undefined && certificationName !== null) {
                return certificationName.length >= this.memberProfileConstants.THREE && this.results.length;
            }
            return false;
        },
        scrollTop() {
            if (this.$refs.certificationDialogId) {
                this.$refs.certificationDialogId.scrollTop = 0;
            }
        },
    },
    computed: {
        ...mapState("actionState", ["actions"]),
        ...mapGetters({
            industory: `memberProfile/${storeGetters.externalConnectionIndustry}`,
            courseAndCertificateSearchResult: `memberProfile/${storeGetters.courseAndCertificateSearchResult}`,
        }),
        saveCertificationAction() {
            return this.actions[storeAction.saveTrainingAndCertification];
        },
        editCertificationAction() {
            return this.actions[storeAction.updateTrainingAndCertification];
        },
        deleteCertificationAction() {
            return this.actions[storeAction.deleteTrainingAndCertification];
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/_colors.scss";

.certification-details {
    border-bottom: 2px solid $ypo-gray;
    margin-bottom: 20px;
    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }
}
.v-card { 
    .select-required {
        color: $ypo-blue;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        margin-left: 600px;
        @media (max-width: 767px){
            display: none;
        }
    }
}
</style>
